// Cinto anti-reincidência (forense UUID, SI.140-C-iii): payment_method é
// vocabulário de slugs; o id bruto do cadastro payment_methods nunca grava.
// Qualquer origem que chegue com UUID é rejeitada antes do INSERT/UPDATE.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function assertPaymentMethodSlug(method?: string | null): void {
  if (method && UUID_RE.test(method)) {
    throw new Error(
      'Forma de pagamento inválida (id bruto do cadastro). Selecione a forma novamente.'
    );
  }
}
